var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPdf = function SvgPdf(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BBB",
    d: "M4.5 2.5a1 1 0 0 1 1-1h9.928L19.5 5.606V21.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBB",
    d: "M15 2v2.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C15.76 6 16.04 6 16.6 6H19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E52910",
    d: "M12 14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C13.52 11 14.08 11 15.2 11h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 12.52 22 13.08 22 14.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 21 19.92 21 18.8 21h-3.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C12 19.48 12 18.92 12 17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.262 13c0 .874-.25 1.904-.672 2.854-.423.955-.994 1.771-1.59 2.253l.647.893c1.605-1.081 3.383-1.822 5.102-1.574L20 16.352c-1.465-.493-2.641-1.973-2.641-3.352zm.715 2.287a10 10 0 0 1-.64 1.55 8.2 8.2 0 0 1 1.576-.46 5.4 5.4 0 0 1-.936-1.09",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5A99F",
    fillRule: "evenodd",
    d: "M7.5 9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM7 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgPdf;